import React from "react";
import { SectionCTA } from "./SectionCTA";
import { AUTHOR_PHOTO_URL } from "../data/offer";
export function AuthorLetter() {
  return <section className="bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-20" data-mp="1vji5tdut0vz0">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[0.85fr_1.15fr] md:gap-14" data-id="element-21" data-mp="1glg5dcj2kqlz">
        <div className="md:sticky md:top-8 md:self-start" data-id="element-22" data-mp="1lj7xa6jpscq6">
          <img src={AUTHOR_PHOTO_URL} alt="Dr. Karito" className="mx-auto aspect-[4/5] w-full max-w-sm rounded-3xl object-cover object-top shadow-xl md:max-w-none" data-id="element-23" data-mp="1llkm93nw3ncq" />
          <p className="mt-4 text-center text-lg font-extrabold text-brand-900" data-id="element-24" data-mp="1zjinr8h43pat">Dr. Karito</p>
          <p className="text-center text-sm text-muted" data-id="element-25" data-mp="1zho9gd0civfp">Author, Perimenopause Clinical Decision Roadmap™</p>
        </div>

        <div data-id="element-26" data-mp="2s7o8hv861ean">
          <p className="text-sm font-bold text-brand-700" data-id="element-27" data-mp="2s7xwxedkbde8">A message from Dr. Karito</p>
          <h2 className="mt-2 text-3xl font-extrabold leading-tight tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-28" data-mp="2wzg26emmc050">
            Clinical decisions deserve a clear process.
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink" data-id="element-29" data-mp="62d7y83lf2kd">
            <p data-id="element-30" data-mp="60a5gol97gyr">Hello, I'm Dr. Karito.</p>
            <p data-id="element-31" data-mp="kr9a5oiyxld2">
              If you work with women experiencing symptoms during the menopausal transition, you know that clinical
              presentations aren't always straightforward.
            </p>
            <p data-id="element-32" data-mp="tqo1sravg1z5">
              Symptoms overlap. Menstrual patterns change. Laboratory findings need context. Patients arrive with
              questions about hormone therapy, nonhormonal options, and what their symptoms might mean. And every
              patient brings a different medical history, set of priorities, and risk profile.
            </p>
            <p data-id="element-33" data-mp="yoxtut1aumgj">
              The purpose of this roadmap is to give you a practical structure for organizing those clinical
              considerations. Inside, you'll find assessment checklists, decision trees, documentation templates, and
              workflow tools designed to support evidence-informed clinical reasoning.
            </p>
            <p data-id="element-34" data-mp="3u8xkfbyuepio">
              Not another collection of disconnected theoretical chapters.{" "}
              <strong className="text-brand-800" data-id="element-35" data-mp="30jreq94dljz">A structured professional reference you can adapt to your practice.</strong>
            </p>
            <p data-id="element-36" data-mp="7ylbneia7qx1">Because good clinical decision-making requires both sound judgment and an organized process.</p>
            <p className="font-extrabold text-brand-900" data-id="element-37" data-mp="cxy5wkbhg09n">— Dr. Karito</p>
          </div>
          <SectionCTA label="Start organizing my cases today" data-id="element-38" data-mp="gz9my1gajd68" />
        </div>
      </div>
    </section>;
}